import type { UniverseReference, User } from '../types/commons';
import type { Booking } from '../types/customer';
import { isRecurring as isRecurringBooking } from './booking';
import { formatPrice } from './formatting';
import moment from './moment';
import { isCareReference } from './universes';

export const DATE_TIME = 'DD/MM - HH[h]mm';

export const composeEventByUniverse = (event: string, universe: UniverseReference, isRecurring: boolean) => {
  const recurrenceType = `_${isRecurring ? 'recurring' : 'spot'}`;
  const recurrence = isCareReference(universe) ? recurrenceType : '';

  return `${event}_${universe}${recurrence}`;
};

export const composeEvent = (event: string, booking: Booking) => {
  const { universe } = booking;

  return composeEventByUniverse(event, universe, isRecurringBooking(booking));
};

export const bookingMetaData = (booking: Booking) => ({
  appointment: moment(booking.appointment).format(DATE_TIME),
  price: formatPrice(booking.total_price),
  address: `${booking.zip_code} ${booking.city}`,
  recurrent: isRecurringBooking(booking),
});

export const userMetaData = (user: User) => ({
  user_id: user.zoho_id,
  name: `${user.first_name} ${user.last_name}`,
  email: user.email,
});
